import React from 'react';
import classnames from 'classnames';
import { formatDateStr } from '@gp/utils/common';
import { newMathFormatOfDevBudget } from '../../../../utils';

import type { IBaseProps } from '@home/types/common';
import type { IDevBudgetChangeHistoryDTO } from '@gp/types/finance';

import './index.scss';

interface IBudgetChangeHistoryProps extends IBaseProps {
  histories?: IDevBudgetChangeHistoryDTO[] | null;
}

// 每个budget change history单元格的宽度
export const BUDGET_CHANGE_HISTORY_CELL_WIDTH = 80;
// 每个budget change history单元格的间距
export const BUDGET_CHANGE_HISTORY_CELL_SPACING = 40;

const BudgetChangeHistory: React.FC<IBudgetChangeHistoryProps> = (props) => {
  const { style, className, histories } = props;

  if (!Array.isArray(histories) || !histories.length) return '-';
  return (
    <div style={style} className={classnames('dbg-budget-change-history', className)}>
      <ul className="dbg-budget-change-history-list">
        {histories.map((history) => {
          const { id, date, value } = history || {};
          return (
            <li
              key={id}
              style={{ marginRight: BUDGET_CHANGE_HISTORY_CELL_SPACING, width: BUDGET_CHANGE_HISTORY_CELL_WIDTH }}
              className="dbg-budget-change-history-item"
            >
              <div className="dbg-budget-change-history-context-row">{formatDateStr(date) || date}</div>
              <div className="dbg-budget-change-history-context-row">{newMathFormatOfDevBudget(value)}</div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BudgetChangeHistory;
